import clsx from 'clsx';
import React from 'react';

import LazyImgixImage from '@components/LazyImgixImage';
import { parameterize } from '@utils/formatting';
import { getImgixSrc } from '@utils/images';

import { ProjectData } from './interface';

const PersonPhoto = ({ person, className }: { person: ProjectData; className?: string }) => {
  const personName = parameterize(person.name);

  return (
    <LazyImgixImage
      alt={`Portrait of ${person.name}`}
      className={clsx('shrink-0 object-cover', className)}
      src={getImgixSrc({
        path: `projects/top_50_influentials_list/${personName.toLowerCase()}.jpg`,
        isEnvDependent: false,
      })}
    />
  );
};

export default PersonPhoto;
